export default "__VITE_ASSET__De4ri5fA__"